import { useEffect, useMemo } from 'react'
import { useLayout } from '../context/LayoutContext'

interface TitleConfig {
  en: string
  zh_cn: string
  zh_hk: string
}

interface PageLayoutOptions {
  showSidebar?: boolean
  showHeader?: boolean
  showFooter?: boolean
  title?: string | TitleConfig
}

export function usePageLayout(options: PageLayoutOptions) {
  const { setLayoutConfig } = useLayout()

  // Memoize the options to prevent unnecessary re-renders
  const memoizedOptions = useMemo(
    () => options,
    [
      options.showSidebar,
      options.showHeader,
      options.showFooter,
      options.title,
    ],
  )

  useEffect(() => {
    setLayoutConfig(memoizedOptions)

    // Reset to default when component unmounts
    return () => {
      setLayoutConfig({
        showSidebar: true,
        showHeader: true,
        showFooter: true,
        title: '',
      })
    }
  }, [setLayoutConfig, memoizedOptions])
}
